var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"outlined":"","hide-details":"auto"},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'v-text-field',{..._vm.input, ..._vm.$attrs},false))
}
var staticRenderFns = []

export { render, staticRenderFns }